import {Button, Space, Tag} from 'antd'
import React, {useContext, useEffect, useState} from 'react'
import PageBuilder from '../../../components/panel/PageBuilder'
import {
    DealerProductFilter,
    useDeleteDealerProductMutation,
    useGetDealerProductsQuery, useGetDealerProductTagsQuery
} from '../../../api/dealerCatalogApi'
import {DeleteOutlined, EditOutlined, EyeOutlined, PlusOutlined} from '@ant-design/icons'
import {useNavigate} from 'react-router-dom'
import ExtendedTable from "../../../components/ExtendedTable";
import {ModalConfirmContext} from "../../../providers/ModalConfirmProvider";
import toast from "react-hot-toast";
import {useFilterTable} from "../../../hooks/useFilterTable";
import {ProductType} from "../../../providers/CatalogProvider";

const DealerProducts = () => {
    const {showModal} = useContext(ModalConfirmContext)
    const navigate = useNavigate()

    const {data: productTags} = useGetDealerProductTagsQuery(null)

    const [filter, setFilter] = useState<DealerProductFilter>({
        page: 1,
        name: '',
        name_sort: '',
        tags: [],

        date_created_range_start: '',
        date_created_range_end: '',
        date_range_created_sort: '',

        date_updated_range_start: '',
        date_updated_range_end: '',
        date_range_updated_sort: '',
    })

    const [deleteItems] = useDeleteDealerProductMutation()
    const {data, isLoading, refetch} = useGetDealerProductsQuery(filter);

    const [
        filterByText,
        filterByData,
        filterBySelect,
    ] = useFilterTable<DealerProductFilter>(filter, setFilter);

    const columns = [
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            ...filterByText('name', "name_sort")
        },
        {
            title: "Date created",
            dataIndex: "date_created",
            ...filterByData("date_created_range_start", "date_created_range_end", "date_range_created_sort"),
        },
        {
            title: "Date updated",
            dataIndex: "date_updated",
            ...filterByData("date_updated_range_start", "date_updated_range_end", "date_range_updated_sort"),
        },
        {
            title: "Tags",
            dataIndex: "tags",
            ...filterBySelect("tags", productTags!, 'name'),
            render: (tags: string[]) => <Space size={[0, 'small']} wrap>
                {
                    tags.map(tag => (
                        <Tag key={tag} color="processing">{tag}</Tag>
                    ))
                }
            </Space>
        },
        {
            title: 'Action',
            dataIndex: 'action',
            key: 'action',
            render: (_: void, product: ProductType) => (
                <>
                    <Button
                        type="link"
                        size="small"
                        onClick={() => {
                            navigate(`/dealer/catalog/edit/${product.id}`)
                        }}
                    >
                        <EditOutlined/>
                    </Button>

                    <Button
                        type="link"
                        size="small"
                        onClick={() => {
                            navigate(`/dealer/catalog/view/${product.id}`)
                        }}
                    >
                        <EyeOutlined/>
                    </Button>

                    <Button
                        onClick={() => {
                            const handleDelete = async () => {
                                const loader = toast.loading("Progressing...");
                                const res = await deleteItems([product.id!.toString()])
                                toast.dismiss(loader);
                                if ('error' in res) return
                                toast.success('Product is successfully deleted!')
                                refetch()
                            }

                            showModal('delete product', handleDelete)
                        }}
                        type="link"
                        size="small"
                    >
                        <DeleteOutlined/>
                    </Button>
                </>
            )
        }
    ]

    useEffect(() => {
        refetch()
    }, [filter])

    return (
        <PageBuilder title="Catalog" documentTitle="Catalog">
            <Space style={{marginBottom: 20}}>
                <Button type="primary" onClick={() => navigate('create')}>
                    <PlusOutlined/> Create Product
                </Button>

                <Button onClick={() => navigate('archive')}>
                    Archived Products
                </Button>
            </Space>

            <ExtendedTable
                data={data}
                isLoading={isLoading}
                dataKey="products"
                columns={columns}
                onChange={(e) => setFilter(prevState => ({...prevState, page: e}))}
            />
        </PageBuilder>
    )
}

export default DealerProducts
